import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, computed } from 'vue';

export interface InputBoxProps {
  modelValue: string | number;
  label: string;
  type: string;
  id: string;
  placeholder: string;
  disabled?: boolean;
  readonly?: boolean;
  required?: boolean;
  error?: string;
  helpText?: string;
  clearable?: boolean;
  inputWrapperClasses?: string;
  inputClasses?: string;
  labelClasses?: string;
  labelWrapperClasses?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'input-box',
  props: {
    modelValue: { default: '' },
    label: { default: '' },
    type: { default: 'text' },
    id: { default: '' },
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: { default: '' },
    helpText: { default: '' },
    clearable: { type: Boolean, default: false },
    inputWrapperClasses: { default: '' },
    inputClasses: { default: '' },
    labelClasses: { default: '' },
    labelWrapperClasses: { default: '' }
  },
  emits: [
  'update:modelValue',
  'focus',
  'blur',
  'keydown',
  'clear',
],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string | number, label: string, type: string, id: string, placeholder: string, disabled: boolean, readonly: boolean, required: boolean, error: string, helpText: string, clearable: boolean, inputWrapperClasses: string, inputClasses: string, labelClasses: string, labelWrapperClasses: string };

const IconClose = defineAsyncComponent(
  () => import('@white-label-icon/icon-close')
);





const labelClasses = computed(() => {
  return props.labelClasses;
});

const labelWrapperClasses = computed(() => {
  return props.labelWrapperClasses;
});

const inputWrapperClasses = computed(() => {
  return props.inputWrapperClasses;
});

const inputClasses = computed(() => {
  const baseClass = 'input-box__input';
  if(props.readonly) {
    return `${baseClass} ${props.inputClasses} input-box__input--readonly`;
  }
  return `${baseClass} ${props.inputClasses}`;
});

const onFocus = () => {
  emit('focus');
};

const onBlur = () => {
  emit('blur');
};

const onClear = () => {
  emit('update:modelValue', '');
  emit('clear');
};

const onKeydown = (event: Event) => {
  emit('keydown', event);
};

return { __sfc: true,IconClose, props, emit, labelClasses, labelWrapperClasses, inputWrapperClasses, inputClasses, onFocus, onBlur, onClear, onKeydown }
}

})